import { render, staticRenderFns } from "./TipoTicketEtapaBoard.vue?vue&type=template&id=0cb3a4de&scoped=true"
import script from "./TipoTicketEtapaBoard.vue?vue&type=script&lang=js"
export * from "./TipoTicketEtapaBoard.vue?vue&type=script&lang=js"
import style0 from "./TipoTicketEtapaBoard.vue?vue&type=style&index=0&id=0cb3a4de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb3a4de",
  null
  
)

export default component.exports